<template>
  <div class="file-data">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>文件数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="数据ID">
          <el-input v-model="searchParams.ogs_id"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size='mini'  @click="fileinsert">新增</el-button>
        </el-form-item> -->
      </el-form>

      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="type"
          label="所属表"
          width ="80px">
        </el-table-column>
        <el-table-column
          prop="obs_id"
          label="数据ID">
        </el-table-column>
        <el-table-column
          prop="level"
          label="数据级别"
          width ="80px">
        </el-table-column>
        <el-table-column
          prop="file_id"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="file_path"
          label="文件路径"
          width ="300px">
        </el-table-column>
        <el-table-column
          prop="ver"
          label="文件版本"
          width ="80px">
        </el-table-column>
        <el-table-column
          prop="archive_time"
          label="数据发布时间">
        </el-table-column>
        <el-table-column
          prop="file_length"
          label="文件长度">
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="FileEdit(scope.row)">
              编辑
            </el-button>
            <!-- <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small"
              @click="FileDelete(scope.row.id)">
              删除
            </el-button>            -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <el-dialog title="数据文件新增" :visible.sync="filedataIsVisible" @close="closefiledataInsertDialog">
        <el-form :inline="true" :model="filedataForm" label-position="right">
          <el-form-item label="数据类别">
            <el-select v-model="filedataForm.currenttable" style="width:200px;" 
            filterable placeholder="所属表：obs/grb/sem">
                  <el-option
                      v-for="item in datatable"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据ID" >
            <el-input v-model="filedataForm.obs_id" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item label="数据级别">
            <el-select style="width:200px;" v-model="filedataForm.level"  filterable placeholder="数据级别1L/2L/1G/1P等">
                  <el-option
                      v-for="item in FileLevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件ID  ">
            <el-input v-model="filedataForm.file_id" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item label="文件路径">
            <el-input v-model="filedataForm.file_path" autocomplete="off" style="width:500px;"></el-input>
          </el-form-item>
          <el-form-item label="文件版本">
            <el-input v-model="filedataForm.ver" autocomplete="off" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="归档时间">
            <el-date-picker v-model="filedataForm.archive_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
          </el-form-item>
          <el-form-item label="文件长度">
            <el-input v-model="filedataForm.file_length" autocomplete="off" style="width:200px;"></el-input>
          </el-form-item>         
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closefiledataInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmFiledataInsertDialog">确定</el-button>
        </div>
      </el-dialog>

      <FiledataEditDialog
        :dialog-visible="FiledataEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmFiledataEditDialog"
        @close="closeFiledataEditDialog">
      </FiledataEditDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {DataLevel,filedatatable} from '../common';
import FiledataEditDialog from './FiledataEditDialog.vue';

export default {
  name: 'FileData',
  components: {
    FiledataEditDialog,
  },
  data() {
    return {
      searchParams: {
        grbid: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      datatable:filedatatable,
      FileLevel:DataLevel,
      filedataForm:{
        currenttable:'',
        ogs_id:'',
        level:'',
        file_id:'',
        file_path:'',
        ver:'',
        archive_time:'',
        file_length:'',
      },
      filedataIsVisible:false,
      FiledataEditIsVisible:false,
      currentDataId:null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/FileData', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    fileinsert(){
      this.filedataIsVisible = true;
      this.filedataForm.currenttable = '';
      this.filedataForm.ogs_id = '';
      this.filedataForm.level = '';
      this.filedataForm.file_id = '';
      this.filedataForm.file_path = '';
      this.filedataForm.ver = '';
      this.filedataForm.archive_time = '';
      this.filedataForm.file_length = '';
    },
    closefiledataInsertDialog(){
      this.filedataIsVisible = false;
    },
    confirmFiledataInsertDialog(){

      this.closefiledataInsertDialog();
      const params = {
        ...this.filedataForm,
      };
      axios.post('/iapi/Fileinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增文件数据成功！');
        }
      });
      this.getData();
    },
    FileDelete(DataID){
      const params = {
        data_id: DataID,
      };
      axios.post('/iapi/Filedelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除文件数据成功！');
        }
      });
      this.getData();
    },
    FileEdit(dataId){
      this.FiledataEditIsVisible = true;
      this.currentDataId = dataId;
    },
    closeFiledataEditDialog(){
      this.FiledataEditIsVisible = false;
    },
    confirmFiledataEditDialog(data){
      this.closeFiledataEditDialog();
      const params = {
        currenttable:data.currenttable,
        ogs_id:data.ogs_id,
        level:data.level,
        file_id:data.file_id,
        file_path:data.file_path,
        ver:data.ver,
        archive_time:data.archive_time,
        file_length:data.file_length,
        id:data.id,        
      }
      axios.post('/iapi/Fileedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑文件数据成功！');
        }
      });
      this.getData();
    },
  },
};
</script>

<style scoped>
.file-data {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 10px;
    margin-bottom: 10px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>